import { FC } from 'react';
import { navigate } from 'gatsby';
import { ButtonPrimary, Form, InputRadio, InputRadioGroup } from '@lambdacurry/component-library';
import { useUpdateSubscriptionFrequencyMutation } from 'lib/home/generated/queries';
import { SubscriptionFrequency } from 'lib/home/generated/types/api';

export interface ChangeSubscriptionFrequencyFormValues {
  frequency: SubscriptionFrequency;
}

export interface ChangeSubscriptionFrequencyFormProps {
  initialValues: ChangeSubscriptionFrequencyFormValues;
}

export const ChangeSubscriptionFrequencyForm: FC<ChangeSubscriptionFrequencyFormProps> = ({ initialValues }) => {
  const { mutate } = useUpdateSubscriptionFrequencyMutation();

  const handleSubmit = ({ frequency }: ChangeSubscriptionFrequencyFormValues) =>
    mutate({ input: { frequency } }, { onSuccess: () => navigate('/') });

  return (
    <Form initialValues={initialValues} onSubmit={handleSubmit}>
      {formikProps => {
        const { initialValues, values } = formikProps;

        return (
          <>
            <InputRadioGroup name="frequency" formikProps={formikProps}>
              <InputRadio data-cy="frequency-input-weekly" label="Weekly" value={SubscriptionFrequency.OneWeek} />
              <InputRadio data-cy="frequency-input-biweekly" label="Biweekly" value={SubscriptionFrequency.TwoWeeks} />
              <InputRadio
                data-cy="frequency-input-triweekly"
                label="Every Three Weeks"
                value={SubscriptionFrequency.ThreeWeeks}
              />
              <InputRadio
                data-cy="frequency-input-fourWeeks"
                label="Every Four Weeks"
                value={SubscriptionFrequency.FourWeeks}
              />
            </InputRadioGroup>

            <ButtonPrimary
              disabled={values.frequency === initialValues.frequency}
              className="mt-2 w-full md:w-56"
              type="submit"
            >
              Submit
            </ButtonPrimary>
          </>
        );
      }}
    </Form>
  );
};
